/*
 * Search
 *
 * @author: Elton Jain
*/

define('modules/Search',[
    'jquery',
    'UI',
    'Helper',
    'JSTemplate'
], function ($, UI, Helper, template) {
    "use strict";
    var q,
        $txt_search = $('.txt-search'),
        suggest_api = '/ajax/search',
        suggest_text = '',
        $elSearchTooltip;
    
    var Search = {
        page: 1,
        $searchPageContainer: $('#searchPageContainer'),
        init: function () {
            this.bindEvents();
        },
        bindEvents: function () {
            var base = this,
            $searchBar = $('#headSearchBar');

            UI.$header.on('click', '#btnHeaderSearch', function () {
                if($searchBar.is('.open')) {
                    $searchBar.removeClass('open');
                    $searchBar.find('input').blur();
                    $('.suggest-tooltip-parent-search').addClass('hidden');
                } else {
                    $searchBar.addClass('open');
                    require(['Mixpanel'], function (MixPanel) {
                        MixPanel.hit('click', {
                            target: 'header search button'
                        });
                    });

                    if($('.suggest-tooltip-parent-search').length > 0) {
                        $('.suggest-tooltip-parent-search').removeClass('hidden');
                    }
                    // $searchBar.find('input').focus();
                }


                return false;
            });

            $txt_search.on('focus',function(ev) {
                if($('.suggest-tooltip-parent-search').length > 0) {
                    $('.suggest-tooltip-parent-search').removeClass('hidden');
                } else {
                    UI.$b.append('<div class="suggest-tooltip-parent-search"></div>').fadeIn('slow');    
                }
            });

            UI.$b.on('click','.search-suggest', function(ev) {
                var base = $(this);

                require(['Mixpanel'], function (MixPanel) {

                    MixPanel.hit('click', {
                        target: 'search suggestions',
                        query: $txt_search.val(),
                        type: base.data('type'),
                        url: base.attr('href')
                    }, function() {
                        window.location = base.attr('href');
                    });


                });

                return false;
            });

            // $txt_search.on('focusout',function(ev) {
            //     $('.suggest-tooltip-parent-search').addClass('hidden');
            // });

            $txt_search.on('keyup', Helper.debounce(function() {

                if($('.suggest-tooltip-search').length > 0) {
                    //$elSearchTooltip.html('');
                    //$elSearchTooltip.addClass('loading');
                } else {
                    var html = template('tplSuggestListContainer');
                    $('.suggest-tooltip-parent-search').append(html);
                    $elSearchTooltip = $('.suggest-tooltip-search > .suggest-tooltip-content');
                }

                q = $txt_search.val().trim();

                if(q == '') {
                    $('.suggest-tooltip-search').remove();
                    return false;
                } else if(q === suggest_text) {
                    return false;
                } else {
                    suggest_text = q;

                    $.post(suggest_api,{
                        q : q,
                        page: 1,
                        suggest: true
                    }, function(response) {
                        $elSearchTooltip.removeClass('loading');

                        var html = template('tplSearchList',{
                            data:response.response,
                            q: q,
                            suggest: true
                        });

                        $elSearchTooltip.html(html);

                        $('.suggest-tooltip-content').css('max-height',$(window).height()/2 + 'px');

                    });
                }

            }, 200));

            // Feed Lazy Loading
            // if(base.$searchPageContainer.length) {

            //     base.$searchPageContainer.on('click', '.btn-load-more', function (e) {

            //         e.preventDefault();

            //         var $btn = $(this),
            //             query = Helper.Url.getParam('q');

            //         base.loadMoreResult(query, {
            //             callback: function () {
            //                 $btn.remove();
            //             }
            //         });

            //         e.stopImmediatePropagation();
            //         return false;
            //     });
            // }
        },
        loadMoreResult: function (query, options) {
            var base = this,
                defaults = {
                    api: "/ajax/search",
                    page: base.page + 1,
                    callback: null
                },
                o = $.extend(defaults, options),
                apiData = {
                    page: o.page,
                    q: $.trim(query)
                };


            if(!$.trim(query)) {
                return false;
            }

            $.post(o.api, apiData, function (response) {
                if(response.status === true) {
                    base.page = o.page;
                    var renderedHtml = base.getListRender(response.response, {
                        page: o.page
                    });

                    base.$searchPageContainer.append(renderedHtml);

                    if(o.callback) {
                        o.callback();
                    }
                }
            });

        },
        getListRender: function (data, options) {
            var base = this,
                searchTemplate = 'tplSearchList',
                defaults = {
                    page: 1
                },
                o = $.extend(defaults, options),
                tmplData = {};

            // Data format {topics: array(), isGroupPage: false, isDetailPage: false}
            tmplData = {
                data: data,
                page: o.page,
            };

            return template(searchTemplate, tmplData);
        }
    };

    Search.init();

    return Search;
});
